module.exports = __webpack_public_path__ + "img/file_ico.f4141ecf.png";